import { BasicCommand } from "../../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../../common/services/cqs/CommandType";
import { IPrimaryKey } from "../../../../common/services/cqs/IPrimaryKey";

export class DeleteSnabbkalkylmallCommand extends BasicCommand<DeleteSnabbkalkylmallCommand> {
    readonly mallId: number;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "DeleteSnabbkalkylmallCommand";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Snabbkalkylmall";

    get primaryKey(): IPrimaryKey<DeleteSnabbkalkylmallCommand> {
        return {
            mallId: this.mallId
        };
    }

    constructor(mallId: number) {
        super(DeleteSnabbkalkylmallCommand.$type, DeleteSnabbkalkylmallCommand.$groupKey, CommandType.Delete);
        this.mallId = mallId;
    }
}
